import React from 'react';
import { useHistory } from 'react-router';
import { makeStyles, Theme } from '@material-ui/core';
import {
    faCommentEdit,
    faComments,
} from '@fortawesome/pro-solid-svg-icons';

import { Page } from '../../components/Page';
import { BackAppBar } from '../../components/BackAppBar';
import { PageBody } from '../../components/PageBody';
import { Menu, MenuItem } from '../../components/Menu';

type FeedbackActionPageProps = {};

FeedbackActionPage.defaultProps = {};

const useStyles = makeStyles((theme: Theme) => ({}));

function FeedbackActionPage(props: FeedbackActionPageProps): React.ReactElement {
    const classes = useStyles();
    const history = useHistory();

    return (
        <Page>
            <BackAppBar
                title="意見反饋"
                onBackClick={() => history.replace('/memberService/action')}
            />
            <PageBody maxWidth="lg">
                <Menu>
                    <MenuItem
                        text="意見反饋"
                        icon={faCommentEdit}
                        onClick={() => history.push('/feedback/add')}
                    />
                    <MenuItem
                        text="意見反饋紀錄"
                        icon={faComments}
                        onClick={() => history.push('/feedback/history')}
                    />
                </Menu>
            </PageBody>
        </Page>
    );
}

export { FeedbackActionPage };
